import NumberFormats from "../NumberFormats";
import NumberFormatter from "../NumberFormatter";

function formatValue(value: number, formatString: string) {
    if (value === 0) {
        return "0";
    }

    if (formatString === NumberFormats.KR_CURRENCY_WON) {
        const currencyString = value.toLocaleString("ko-KR", { style: "currency", currency: "KRW" });
        return `${currencyString.replace("₩", "")}원`;
    }

    if (formatString === NumberFormats.KR_CURRENCY_SYMBOL) {
        const currencyString = value.toLocaleString("ko-KR", { style: "currency", currency: "KRW" });
        return `${currencyString}`;
    }
    if (formatString === NumberFormats.KR_CURRENCY_CHEON_WON) {
        return `${value}천원`;
    }
    if (formatString === NumberFormats.KR_CURRENCY_MAN_WON) {
        return `${value}만원`;
    }
    if (formatString === NumberFormats.KR_CURRENCY_BAKMAN_WON) {
        return `${value}백만원`;
    }
    if (formatString === NumberFormats.KR_CURRENCY_CHEONMAN_WON) {
        return `${value}천만원`;
    }

    if (formatString === NumberFormats.KR_CURRENCY_EOK_WON) {
        return `${value}억원`;
    }
    return `${value}₩`;
}
export default function createCurrencyFormatter(
    config: {
        description?: string;
        formatString?: string;
        label?: string;
    } = {}
) {
    const { description, formatString = "won", label } = config;

    return new NumberFormatter({
        description,
        formatFunc: (value) => formatValue(value, formatString),
        id: formatString,
        label,
    });
}
